angular.module('app').config(['$stateProvider', '$urlRouterProvider', '$ocLazyLoadProvider', function ($stateProvider, $urlRouterProvider, $ocLazyLoadProvider) {
  $urlRouterProvider.otherwise('/login');
  $stateProvider.state('access', {
    url: '',
    template: '<div class="full-height" ui-view></div>'
  }).state('access.login', {
    url: '/login?token',
    templateUrl: 'login_dts.html'
  }).state('access.old_login', {
    url: '/access/login?token',
    templateUrl: 'login_dts.html'
  });
}]);